module.exports = __webpack_public_path__ + "static/assets/63204626162f57bdd85488e2a3327377.svg";